module.exports = __webpack_public_path__ + "img/schedule-event.7d99698a.svg";